const styles = {
  backButton: {
    color: "primary.main",
    backgroundColor: "#F1F2EF",
    "&:hover": {
      backgroundColor: "#E1E2DE",
    },
    py: 1,
    px: 4,
  },
};

export default styles;
